export default __webpack_public_path__ + "static/media/CRM-1.a9546c57.png";